import React, { useEffect, useState } from "react";
import { Form } from "antd";
import dayjs from "dayjs";
import SOURCES from "../../../../utils/constants";
import CommonForm from "../../../global/form";
import CommonDialog from "../../../global/dialog";
import { usePaymentPlans } from "../../../../queries/common/use-payment-plans";
import { useGenericQuery } from "../../../../queries/use-generic-query";
import { QUERY_KEYS } from "../../../../lib/query-constants";

const EnhancedAddCoupon = ({ showForm, setShowForm, getUsers, id, parentMethod, editCoupon, addCouponMutation, updateCouponMutation }) => {
  const [form] = Form.useForm();

  const { data: paymentPlans } = usePaymentPlans({ endpoint: "payment/plans" });

  const getPlans = () => {
    if (Array.isArray(paymentPlans) && paymentPlans.length > 0) {
      return paymentPlans?.map((item) => ({
        label: item.planName,
        value: item._id,
      }));
    }
    return [];
  };


  // get coupons
  const { data: coupon, isLoading: isLoadingCoupon } = useGenericQuery({
    queryKey: QUERY_KEYS.coupon.item({ id: editCoupon.id }),
    queryParams: { id: editCoupon.id },
    endpoint: "coupon",
    enabled: editCoupon.isEditable && !!editCoupon.id
  })


  useEffect(() => {
    if (coupon && editCoupon.id) {
      if (parentMethod) parentMethod();
      else {
        console.log("inside else with these values", coupon)
        form.setFieldsValue({
          "coupon-code": coupon.code,
          "coupon-type": coupon.couponType,
          "amount": coupon.amount,
          "expiry-date": coupon.expiryDate ? dayjs(coupon.expiryDate) : null,
          "total-usage-allowed": coupon.usageAllowed,
          "choosePlan": coupon?.upgradeToPlanId,
        });
        // setShowForm(true);
      }
    }
  }, [coupon, parentMethod]);

  const handleSubmit = async () => {
    form
      .validateFields()
      .then(async (values) => {
        console.log("Form values:", values);
        const payload = {
          amount: values.amount,
          code: values["coupon-code"],
          couponType: values["coupon-type"],
          expiryDate: values["expiry-date"],
          paymentPlanId: values.choosePlan,
          usageAllowed: values["total-usage-allowed"] || 0,
        }

        try {
          editCoupon.isEditable ? await updateCouponMutation.mutateAsync({ ...payload, id: editCoupon.id }) : await addCouponMutation.mutateAsync({ ...payload })
        } catch (err) {
          console.log(err);
        }
      })
      .catch((err) => {
        console.log("Validation failed", err);
      });
  };

  const formData = [
    {
      label: "Coupon Code",
      name: "coupon-code",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "text",
      placeholder: "Enter coupon code.",
      required: true,
      message: "Coupon code is required.",
    },
    {
      label: "Coupon Type",
      name: "coupon-type",
      inputType: SOURCES.FORMINPUTTYPES.SELECT,
      type: "select",
      placeholder: "Select coupon type.",
      required: true,
      options: [
        { label: "Fixed", value: SOURCES.DISCOUNT_FIXED },
        { label: "Percentage", value: SOURCES.DISCOUNT_PERCENTAGE },
        { label: "Trial", value: SOURCES.DISCOUNT_TRIAL },
      ],
      message: "Coupon type is required.",
    },
    {
      label: "Amount",
      name: "amount",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "number",
      placeholder: "Enter amount.",
      required: true,
      message: "Amount is required.",
    },
    {
      label: "Expiry Date",
      name: "expiry-date",
      inputType: SOURCES.FORMINPUTTYPES.DATE,
      type: "date",
      required: true,
      message: "Expiry date is required.",
    },
    {
      label: "Total Usage Allowed",
      subTitle: "Leave blank for unlimited usage.",
      name: "total-usage-allowed",
      inputType: SOURCES.FORMINPUTTYPES.INPUT,
      type: "number",
      placeholder: "Enter usage allowed.",
      required: false,
    },
    {
      label: "Upgrade To Plan",
      name: "choosePlan",
      inputType: SOURCES.FORMINPUTTYPES.SELECT,
      type: "select",
      placeholder: "Choose plan.",
      required: false,
      span: 12,
      options: getPlans(),
    },
  ];

  return (
    <CommonDialog
      title={editCoupon.isEditable ? "Edit Coupon" : "Add Coupon"}
      description={editCoupon.isEditable ? "Modify the existing coupon details and save your changes." : "Fill the form to add a new coupon."}
      open={showForm}
      setOpen={setShowForm}
      onOk={() => handleSubmit()}
      isConfirmButtonLoading={addCouponMutation.isPending || updateCouponMutation.isPending}
      onCancel={() => setShowForm(false)}
      okButtonTitle={editCoupon.isEditable ? "Update" : "Confirm"}
      className="relative overflow-hidden"
    >
      {
        (editCoupon.isEditable && isLoadingCoupon) && <div className="absolute -top-2 left-0 w-full h-full bg-black/15 z-10 rounded-lg flex justify-center items-center">
          <div className="flex flex-col justify-center items-center gap-1">
            <div className="size-6 rounded-full border-2 border-white !border-t-primary animate-spin" />
          </div>
        </div>
      }
      <CommonForm
        data={formData}
        // onSubmit={(values) => console.log(values)}
        className="mt-4"
        layoutType="vertical"
        form={form}
      />
    </CommonDialog>
  );
};

export default EnhancedAddCoupon;
